<template>
	<div>
		<div style="display: flex; align-items: center">
			<div class="leftClick" @click="onClickLeft">
				<van-icon name="../../../static/images/mobile/back.png" />
			</div>
			<van-search :autofocus="true" v-model="value" show-action placeholder="请输入课程名称" @search="get_search">
				<template #action>
					<div @click="get_search">搜索</div>
				</template>
			</van-search>
		</div>
		<div class="history" v-show="!classNums">
			<p class="note">
				<span>最近搜索</span>
				<van-icon @click="empty" name="../../../static/images/mobile/remove.png" />
			</p>
			<ul v-if="historyList.length > 0">
				<li class="historyLists" v-for="(item, index) in historyList" :key="index">
					<div @click="goSearchDetail(item)">{{ item }}</div>
					<van-icon @click="emptyone(index)" name="../../../static/images/mobile/removex.png" />
				</li>
			</ul>
			<p v-else style="text-align: center; margin: 0 auto; font-size: 16px; margin-top: 20px">暂无搜索记录</p>
		</div>
		<div class="classNums" v-show="classNums">
			共搜索到 <span>{{ classNum }}</span> 门课
		</div>
		<van-empty v-show="classNum == 0 ? true : false" class="custom-image" image="../../../static/images/mobile/examNum.png" description="暂无课程" />
		<div class="mobile-hot">
			<ul>
				<li v-for="list in list" :key="list.id" @click="goToGoodsDetails(list.id)">
                    <div class="mobile-hot-img"><img :src="list.pictureUrl" /></div>
					<h5 class="mobile-hot-title">视频 |{{ list.goodsName }}</h5>
					<span v-if="list.categoryName" class="classify fl">{{ list.categoryName }}</span>
					<span class="period">{{ list.testHours }}学时 </span>
					<div class="classPrice fr" style="color: #dc0021; font-weight: 400">￥{{ list.platformPrice }}</div>
				</li>
			</ul>
		</div>
		<div class="classfooter" v-if="courseCenter.length >= 1 ? true : false">已经到底了</div>
	</div>
</template>

<script>
export default {
	name: "Search",
	data() {
		return {
			value: "", //搜索的内容
			courseCenter: [],
			historyList: [], //历史搜索记录，存本地
			categoryPath: "",
			classNum: "-1",
			classNums: false,
            loading: false, // 是否处在加载状态
			finished: false, // 是否已加载完成
			error: false, // 是否加载失败
			list: [], // 列表
			pageNumber: 1, // 分页
			pageSize: 10, // 每页条数
			total: 0,
		};
	},
	methods: {
        /**
		 * 课程中心初始化
		 * @param sortKey 排序字段 (BUYNMBER:按购买数量排序);(BUYPRICE:按销售价格排序);(BROWSE:按浏览量);(NEW:按最新上架进行排序)
		 * @param sortWay 排序方式 1(升序) ,2(降序)
		 * @param sortPath  排序的路径  例如 -1001-
		 */
		onSearch: function () {
			let param = {};
			param.name = this.value;
			param.number = this.pageNumber;
			param.size = this.pageSize;
			param.categoryPath = this.$route.query.categoryPath;
			this.$api.get("/web/getGoodsInfoList", param, (res) => {
				if (res.code == "SUCCESS") {
					if (res.data.rows === 0) {
						// 判断获取数据条数若等于0
						this.list = []; // 清空数组
						this.finished = true; // 停止加载
					}
					// 若数据条数不等于0
					this.classNum = res.data.total; // 给数据条数赋值
					this.list.push(...res.data.rows); // 将数据放入list中
					this.loading = false; // 加载状态结束
                    this.classNums = true;
					// 如果list长度大于等于总数据条数,数据全部加载完成
					if (this.list.length >= res.data.total) {
						this.finished = true; // 结束加载状态
					}

					// this.courseCenter = res.data.rows;
					// this.classNum = res.data.total;
					// this.classNums = true;
				} else {
					this.$message.error(res.message);
				}
			});
		},
        // 被 @load调用的方法
		onLoad() {
			// 若加载条到了底部
			this.onSearch(); // 调用上面方法,请求数据
			this.pageNumber++; // 分页数加一
		},
		// 加载失败调用方法
		onRefresh() {
			this.finished = false; // 清空列表数据
			this.loading = true; // 将 loading 设置为 true，表示处于加载状态
			this.pageNumber = 1; // 分页数赋值为1
			this.list = []; // 清空数组
			this.onLoad(); // 重新加载数据
		},
		// 搜索
		get_search() {
			if (this.value == "") {
				this.$notify({ type: "primary", message: "请输入搜索内容" });
				return false;
			} else {
				// 没有搜索记录，把搜索值push进数组首位，存入本地
				if (!this.historyList.includes(this.value)) {
					this.historyList.unshift(this.value);
					localStorage.setItem("historyList", JSON.stringify(this.historyList));
				} else {
					//有搜索记录，删除之前的旧记录，将新搜索值重新push到数组首位
					let i = this.historyList.indexOf(this.value);
					this.historyList.splice(i, 1);
					this.historyList.unshift(this.value);
					localStorage.setItem("historyList", JSON.stringify(this.historyList));
				}
				this.onSearch()
			}
		},
		//点击历史搜索，跳转搜索结果页
		goSearchDetail(title) {
			let param = {};
			param.name = title;
			param.number = this.pageNumber;
			param.size = this.pageSize;
			this.$api.get("/web/getGoodsInfoList", param, (res) => {
				if (res.code == "SUCCESS") {
					if (res.data.total > 0) {
						this.list = res.data.rows;
						this.classNum = res.data.total;
						this.classNums = true;
					}
					{
						this.classNum = res.data.total;
						this.classNums = true;
					}
				} else {
					this.$message.error(res.message);
				}
			});
		},
		emptyone(item) {
			var list = JSON.parse(localStorage.getItem("historyList"));
			list.splice(item, 1);
			localStorage.setItem("historyList", JSON.stringify(list));
			this.historyList = JSON.parse(localStorage.getItem("historyList"));
		},

		//清空历史搜索记录
		empty() {
			this.$notify({ type: "success", message: "清空历史搜索成功" });
			localStorage.removeItem("historyList");
			this.historyList = [];
		},
		goToGoodsDetails: function (goodsId) {
			this.$router.push({ path: "/mobileCourseDetail", query: { id: goodsId } });
		},
		//返回上一步
		onClickLeft() {
			this.$router.go(-1);
		},
	},
	mounted() {
		//如果本地存储的数据historyList有值，直接赋值给data中的historyList
		if (JSON.parse(localStorage.getItem("historyList"))) {
			this.historyList = JSON.parse(localStorage.getItem("historyList"));
		}
	},
	created() {},
};
</script>

<style scoped>
.classPrice {
	margin-right: 0.426667rem;
	font-size: 0.32rem;
}
.leftClick {
	margin-left: 0.426667rem;
	width: 0.426667rem;
	height: 0.426667rem;
    margin-bottom: .213333rem;
}
.leftClick .van-icon img{
	width: .426667rem;
    height: .426667rem;
}
.van-search__content {
	width: 7.44rem;
	height: 0.853333rem;
	background: #f3f3f5;
	opacity: 1;
	border-radius: 0.48rem;
}
.history .note {
	margin-top: 0.7rem;
	margin-bottom: 0.426667rem;
	display: flex;
	justify-content: space-between;
}
.history .note span {
	margin-left: 0.426667rem;
	color: #000000;
	font-weight: bold;
	font-size: 0.373333rem;
}
.history .note .van-icon img {
	margin-right: 0.426667rem;
	width: 0.533333rem;
	height: 0.533333rem;
}
.historyLists {
	height: 0.64rem;
	background: #f3f3f5;
	opacity: 1;
	border-radius: 0.426667rem;
	margin-left: 0.426667rem;
}

.historyLists .van-icon img {
	margin-left: 0.32rem;
	margin-right: 0.32rem;
	width: 0.213333rem;
	height: 0.213333rem;
	margin-bottom: 0.04rem;
}
.historyLists div {
	display: inline-block;
	margin: 0.106667rem 0rem 0.106667rem 0.32rem;
	vertical-align: middle;
	line-height: 0.48rem;
}
.history ul {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: 0.533333rem;
}
.classfooter {
	text-align: center;
	font-weight: 400;
	color: #adadad;
	font-size: 0.293333rem;
}
.classNums {
	margin-top: 0.666667rem;
	color: #adadad;
	font-weight: 400;
	font-size: 0.293333rem;
	margin-left: 0.426667rem;
}
.classNums span {
	color: #555555;
}
.mobile-hot-title {
	margin-left: 0.426667rem;
	color: #000000;
	font-weight: bold;
	font-size: 0.426667rem;
}
.historyLists {
	margin-bottom: 0.2rem;
}
.mobile-hot-img {
	border-radius: 0.106667rem 0.106667rem 0rem 0rem;
	overflow: hidden;
}
.van-search__action{
    padding-left: .32rem;
    padding-right: .426667rem;
}
</style>


// WEBPACK FOOTER //
// MobileSearchResult.vue?845ecc82